import { render, staticRenderFns } from "./NoOperateOrderEdit.vue?vue&type=template&id=22b827b4&scoped=true"
import script from "./NoOperateOrderEdit.vue?vue&type=script&lang=js"
export * from "./NoOperateOrderEdit.vue?vue&type=script&lang=js"
import style0 from "./NoOperateOrderEdit.vue?vue&type=style&index=0&id=22b827b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b827b4",
  null
  
)

export default component.exports